// @ts-nocheck
import * as React from "react";

const Options2Fill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M9.976 15.204A3 3 0 0113.82 17H21a1 1 0 110 2h-7.18a3 3 0 01-5.64 0H3a1 1 0 110-2h5.18a3 3 0 011.796-1.796zM19 9l.19.005A3 3 0 1116.18 13H3a1 1 0 110-2h13.18A3 3 0 0119 9zM5.976 3.204A3 3 0 019.82 5H21a1 1 0 110 2H9.82a3 3 0 01-5.64 0H3a1 1 0 110-2h1.18a3 3 0 011.796-1.796z"
            />
        </svg>
    );
};

export default React.memo(Options2Fill);
